import type { ReactNode } from "react"
import { AlertCircle } from "react-feather"
import { type CommonsDialogProps, Dialog } from "../Dialog"

export interface ConfirmDialogProps
  extends Pick<CommonsDialogProps, "open" | "title" | "subtitle" | "Icon"> {
  message: ReactNode
  validateButtonText?: string
  validateAction: () => void
  cancelAction?: () => void
  onClickClose: () => void
}

export const ConfirmDialog = ({
  open,
  title,
  subtitle,
  message,
  validateButtonText,
  validateAction,
  cancelAction,
  onClickClose,
  Icon = AlertCircle,
}: ConfirmDialogProps) => (
  <Dialog
    Icon={Icon}
    title={title}
    subtitle={subtitle}
    validateAction={() => {
      validateAction()
      onClickClose()
    }}
    validateText={validateButtonText}
    cancelAction={() => {
      cancelAction?.()
      onClickClose()
    }}
    open={open}
    onClose={onClickClose}
  >
    {message}
  </Dialog>
)
